/* tslint:disable */
/* eslint-disable */
/**
 * MedicalOperations API
 * This is an OpenAPI for the MedicalOperations Microservice
 *
 * OpenAPI spec version: 0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AppointmentEmployee } from './appointment-employee';
import { FastAppointmentPatient } from './fast-appointment-patient';
import { PatientObservations } from './patient-observations';
 /**
 * 
 *
 * @export
 * @interface Appointment
 */
export interface Appointment {

    /**
     * @type {string}
     * @memberof Appointment
     */
    ParentAppointmentID?: string;

    /**
     * @type {string}
     * @memberof Appointment
     */
    AppointmentID: string;

    /**
     * @type {string}
     * @memberof Appointment
     * @example Severe Headache and Insomnia.
     */
    ConsultationReason: string;

    /**
     * @type {string}
     * @memberof Appointment
     */
    TenantID: string;

    /**
     * @type {string}
     * @memberof Appointment
     */
    BranchID: string;

    /**
     * @type {string}
     * @memberof Appointment
     */
    Status: AppointmentStatusEnum;

    /**
     * determines whether this appointment has a follow up or not.
     *
     * @type {boolean}
     * @memberof Appointment
     * @example true
     */
    IsLeaf?: boolean;

    /**
     * @type {Date}
     * @memberof Appointment
     */
    DateTo: Date;

    /**
     * @type {string}
     * @memberof Appointment
     * @example Patient has been referred by Dr Phil
     */
    Notes: string;

    /**
     * @type {number}
     * @memberof Appointment
     * @example 8
     */
    Priority: number;

    /**
     * @type {Date}
     * @memberof Appointment
     */
    DateFrom: Date;

    /**
     * @type {FastAppointmentPatient}
     * @memberof Appointment
     */
    Patient: FastAppointmentPatient;

    /**
     * @type {AppointmentEmployee}
     * @memberof Appointment
     */
    Employee: AppointmentEmployee;

    /**
     * @type {Array<PatientObservations>}
     * @memberof Appointment
     */
    Observations?: Array<PatientObservations>;

    /**
     * @type {Date}
     * @memberof Appointment
     */
    DateCreated: Date;

    /**
     * @type {Date}
     * @memberof Appointment
     */
    DateModified: Date;
}

/**
 * @export
 * @enum {string}
 */
export enum AppointmentStatusEnum {
    PendingFollowup = 'Pending Followup',
    Missed = 'Missed',
    Canceled = 'Canceled',
    Closed = 'Closed',
    Scheduled = 'Scheduled'
}

